export const header = {
    english: {
        title: "Adolescent Fertility Rate (AFR) in Nepal",
        subTitle: "Better evidence to drive more impactful allocation of family planning resources",
        home: "Home",
        map: "Map",
        tour: 'Start a tour',
        contact: "Contact",
        about: "About"
    },
    nepali: {
        title: "नेपालमा किशोरकिशोरी प्रजनन् दर",
        subTitle: "परिवार नियोजन संसाधनहरुको बढि प्रभावकारी बााँडफााँडको संचालन गर्न उपयुक्त तथ्यहरू",
        home: "गृह",
        map: "नक्शा",
        tour: 'भ्रमण गर्नुहोस्',
        contact: "सम्पर्क",
        about: "वारे"
    },
};

export const about = {
    english: {
        title: 'PACE Nepal',
        subTitle: 'Interactive Digital Map',
        paragraphs: [
            `In 2019-2020, the PACE Project developed modelled estimates of adolescent fertility at
            the municipal level in Nepal for 2011 and 2016. This information can help decisionmakers
            and other stakeholders working in family planning or adolescent fertility in Nepal
            understand patterns and trends in adolescent fertility in locations throughout Nepal
            and make informed decisions to reduce adolescent fertility.`,

            `This online digital interactive map, available in both English and Nepali, allows
            users to customize visualizations of patterns and trends in adolescent fertility
            rates, either among all girls 15-19 or married girls, and by municipality, district,
            or province. These data can be used to examine how adolescent fertility rates compare
            between municipalities in 2016 and which municipalities have seen declines, little
            change, or increases in their estimated adolescent fertility rates from 2011 to 2016.`,

            `Users can customize the digital map using the drop-down boxes at the top and the menu
            panel on the left. From the drop-down box on the top labelled Layer View, users can
            select the geographic layer for the map (provinces, districts, or municipalities).
            Users can also use the Province, District, and Municipality drop-down boxes to zoom
            in on a particular province, district, or municipality. On the menu panel on the left,
            you can change the fertility indicator you would like to see (for example, looking at
            the overall adolescent fertility rate in 2016, the percent change in adolescent
            fertility from 2011 to 2016, or both combined) by selecting a different fertility
            layer. You can also see dots representing the total number of births to adolescent
            girls by adding a population layer. Finally, the base maps button in the top right
            allows users to add on a OpenStreetMap or satellite map layer to the map.`,
        ],
        disclaimer: {
            title: 'Note',
            description: `The boundaries and names used on this map do not imply official
                endorsement or acceptance by the U.S. Government or the United States Agency
                for International Development (USAID), or the Survey Department, Government of
                Nepal.`,
        },
        close: 'Close',
    },
    nepali: {
        title: 'पेस नेपाल',
        subTitle: 'अन्तर्क्रियात्मक डिजिटल नक्शा',
        paragraphs: [
            `सन् २०१९-२०२० मा  PACE परियोजनाले सन् २०११ र २०१६ का लागि नेपालको पालिका स्तरमा किशोरकिशोरी प्रजननदर
            मोडल अनुमान विकास गर्‍यो। यस जानकारीले निर्णयकर्ताहरू र परिवार नियोजन वा किशोरकिशोरीहरुको प्रजननमा काम गरिरहेका
            अन्य सरोकारवालाहरुलाई नेपालमा किशोरकिशोरी प्रजननदरको प्रकृति र प्रवृत्ति बुझ्न मद्दत गर्न सक्दछ । साथै नेपाल भरको
            किशोरकिशोरी प्रजननदर कम गर्न  सूचित निर्णयहरु लिन सहयोग गर्दछ ।`,

            `यस अनलाइन डिजिटल अन्तर्क्रियात्मक नक्शा दुबै अंग्रेजी र नेपाली भाषामा उपलब्ध छ । प्रयोगकर्ताहरूले यस नक्शाबाट
            पालिका, जिल्ला वा प्रदेश स्तर को १५-१९ उमेर समूहका  सम्पूर्ण किशोरीहरु वा विवाहित किशोरिहरूको प्रजननदरको प्रकृति
            र प्रवृत्तिहरूलाई ईच्छा अनुरूप प्रस्तुत गर्न सक्दछन् । नक्सामा उद्रित गरिएका तथ्यांकहरु प्रयोग गरि पालिकाहरूबिच सन् २०१६
            को  किशोरकिशोरी प्रजननदरहरूको तुलना कसरी गरियो र सन् २०११ देखी २०१६ सम्म कुन-कुन पालिकाहरुमा अनुमानित
            किशोरकिशोरी प्रजननदर घट्यो, थोरैले परिवर्तन भयो, वा बृद्धि भयो भन्ने देखाउदछ ।`,

            `प्रयोगकर्ताहरूले डिजिटल नक्साको माथिल्लो भागमा रहेको ड्रप-डाउन बक्सहरू र बायाँपट्टी मेनू सूची प्रयोग गरेर आफ्नो ईच्छा
            वा आवश्यकता अनुरूप नक्साको प्रयोग गर्न सक्द्छन । नक्साको माथिल्लो भागमा रहेको ड्रप-डाउन बक्सबाट तपाईहरूले हेर्न
            चाहानु भएको भौगोलिक तह (प्रदेश, जिल्ला, वा पालिका) को चयन गर्न सक्नुहुनेछ । त्यसै गरी प्रदेश, जिल्ला, र पालिकाका
            ड्रप-डाउन बक्सहरू प्रयोग गरी विशेष प्रदेश, जिल्ला, वा पालिका जुम गर्नसक्नुहुनेछ । बाँया तर्फ रहेको मेनु सूचीमा प्रयोगकर्ताहरूले
            हेर्न चाहेको प्रजनन सूचक परिवर्तन गर्न सक्नु हुने छ । उदाहरणका लागि २०१६ को समग्र किशोरकिशोरी प्रजननदर, २०११
            देखि २०१६ सम्मको किशोरकिशोरी प्रजननदरमा आएको परिवर्तन (प्रतिशतमा), वा दुबै मिश्रित चयन गरेर हेर्न सक्नुहुनेछ ।
            तपाईहरूले  जनसंख्या तह थपेर किशोरीहरूबाटको जन्मको कुल संख्या प्रतिनिधित्व गर्ने डटहरू पनि देख्न सक्नुहुनेछ । अन्तमा,
            माथिको दायाँतर्फ रहेको  आधार नक्सा बटनले प्रयोगकर्ताहरूलाई खुला सडक नक्सा (OpenStreetMap) वा उपग्रह (Satellite)
            नक्सा थप्न अनुमति दिन्छ।`,
        ],
        disclaimer: {
            title: 'नोट',
            description:
                `नक्शामा प्रयोग भएका सिमारेखाहरु तथा नामहरु संयुक्त राज्य सरकार वा USAID, वा नापी विभाग, नेपाल
                सरकार बाट आधिकारिक रुपमा अनुमोदन वा स्वीकृत गराइएको छैन।`,
        },
        close: 'बन्द गर्नुहोस्',
    }
};

export const tourSteps = [
    {
        english: { title: "Welcome", description: "Let's start the tour of this website." },
        nepali: { title: "स्वागतम", description: "यो वेवसाइटको भ्रमण सुरुवात गर्नुहोस्।" }
    },
    {
        selector: '#map-link',
        english: { title: "Map Menu", description: "You are currently in the interactive map page." },
        nepali: { title: "नक्शाको मेनु", description: "तपाँई अहिले अन्तर्क्रियात्मक डिजिटल नक्शा पेजमा हुनुहुन्छ।" },
        position: 'left',
    },
    {
        selector: '#take-a-tour',
        english: { title: "Take a tour Menu", description: "Click here to start this website tour." },
        nepali: { title: "भ्रमण गर्नुहोस् मेनु", description: "यो वेवसाइटको भ्रमण गर्न यहां क्लिक गर्नुहोस्।" },
        position: 'left',
    },
    {
        selector: '#about-link',
        english: { title: "About Menu", description: "Click here to read about us." },
        nepali: { title: "वारे मेनु", description: "हाम्रो वारे पढ्न यहां क्लिक गर्नुहोस्।" },
        position: 'left',
    },
    {
        selector: '#language-toggler',
        english: { title: "Language Menu", description: "Click here to toggle language (EN/NP)." },
        nepali: { title: "भाषा मेनु", description: "भाषा परिवर्तन गर्न यहां क्लिक गर्नुहोस्।" },
        position: 'left',
    },
    {
        selector: '#map',
        english: { title: "Map", description: "Interactive map where all the layers are visualized." },
        nepali: { title: "नक्शा", description: "अन्तर्क्रियात्मक नक्शा जहां सवै लेयर्सहरु हेरिन्छ।" },
        position: 'left',
    },
    {
        selector: '.base-layer-select-toggler',
        english: { title: "Base Layers", description: "Hover here to select the base map (OSM/ Satellite/ None)." },
        nepali: { title: "आधार नक्शाहरु", description: "आधार नक्शा (OSM/Satellite/None) छनोट गर्न यहां छुनुहोस्।" },
        position: 'left',
    },
    {
        selector: '#map div.ol-scale-line.ol-unselectable > div',
        english: { title: "Map Scale", description: "This shows the current scale of the map displayed." },
        nepali: { title: "नक्शाको स्केल", description: "यसले हेरिएको नक्शाको स्केल देखाउंछ।" },
        position: 'left',
    },
    {
        selector: '.ol-mouse-position',
        english: { title: "Location", description: "This shows the corresponding coordinates of mouse position in the map." },
        nepali: { title: "स्थान", description: "यसले माउसको स्थितिको सम्बन्धित निर्देशांकहरु देखाउन्छ।" },
        position: 'top',
    },
    {
        selector: '.legend-wrapper',
        english: { title: "Data value", description: "The data of the region you hovered over will be displayed here." },
        nepali: { title: "तथ्यांकको मान", description: "माउसले छोएको भौगोलिक सिमानाको तथ्यांकको मान यहां देखा पर्छ।" },
        position: 'right',
    },
    {
        selector: '.added.printer-icon',
        english: { title: "Print Map", description: "Click here to print the displayed map." },
        nepali: { title: "नक्शाको प्रिन्ट गर्नुहोस्।", description: "देखिएको नक्शा प्रिन्ट गर्न यहां क्लिक गर्नुहोस्।" },
        position: 'right',
    },
    {
        selector: '.added.zoom-to-location',
        english: { title: "Zoom to location", description: "Click here to enter longitude and latitude coordinates of a specific location and zoom into it." },
        nepali: { title: "स्थानिय निर्देशांकमा जुम गर्नुहोस्।", description: "अक्षांस र देशान्तर प्रविष्ट गरी जुम गर्न यहां क्लिक गर्नुहोस्।" },
        position: 'right',
    },
    {
        selector: '#nepal-extent-tool',
        english: { title: "Reset zoom”", description: "Click to reset zoom to the national level." },
        nepali: { title: "विस्तारित जुम गर्नुहोस्", description: "नेपालको विस्तारीत नक्शा हेर्न यहां क्लिक गर्नुहोस्।" },
        position: 'right',
    },
    {
        selector: '.ol-zoom.ol-unselectable.ol-control',
        english: { title: "Zoom tool", description: "Zoom tool for zooming in and out." },
        nepali: { title: "जुम गर्ने टुल", description: "ठूलो र सानो जुम गर्ने टुल" },
        position: 'right',
    },
    {
        selector: '.layer-view',
        english: { title: "National Geography Selection Tool", description: "Select a geography to view map at this geographic level." },
        nepali: { title: "राष्ट्रीय स्तरको भुगोल छनोट गर्ने टुल", description: "राष्ट्रीय स्तरको भुगोल छनोट गर्ने टुल" },
        position: 'bottom',
    },
    {
        selector: '.region-select-wrapper.row > div:nth-child(2)',
        english: { title: "Province Selection Tool", description: "Select any province to view map at this geographic level." },
        nepali: { title: "प्रादेशिक स्तरको छनोट गर्ने टुल", description: "प्रादेशीक नक्शा हेर्न कुनै प्रदेश छनोट गर्नुहोस्।" },
        position: 'bottom',
    },
    {
        selector: '.region-select-wrapper.row > div:nth-child(3)',
        english: { title: "District Selection Tool", description: "Select any district to view map at this geographic level." },
        nepali: { title: "जिल्ला स्तरको छनोट गर्ने टुल", description: "जिल्लाको नक्शा हेर्न कुनै जिल्ला छनोट गर्नुहोस्।" },
        position: 'bottom',
    },
    {
        selector: '.region-select-wrapper.row > div:nth-child(4)',
        english: { title: "Municipality Selection Tool", description: "Select any municipality to view map at this geographic level." },
        nepali: { title: "पालिका स्तरको छनोट गर्ने टुल", description: "पालिकाको नक्शा हेर्न कुनै पालिका छनोट गर्नुहोस्।" },
        position: 'bottom',
    },
    {
        selector: '.side-bar',
        english: { title: "Table of Contents", description: "This is the list of all layers that can be checked on/off to visualize and hide the layers in the map." },
        nepali: { title: "लेयर्सको तालिका", description: "यो सबै लेयरहरुलाई नक्शामा हेर्न र हटाउन, चेक गर्ने या नगर्ने गर्न सकिन्छ।" },
        position: 'bottom',
    },
    {
        selector: '.show-sidebar-btn',
        english: { title: "Sidebar Toggler", description: "Click here to toggle the table of contents." },
        nepali: { title: "छेउको वार हेर्न वा लुकाउन", description: "लेयरहरुको तालिका हेर्न वा लुकाउन यहां क्लिक गर्नुहोस्।" },
        position: 'bottom',
    },
];